let CameraHandler = function (___settings, ___handlers) {
  const THREE = require('../../../../../externals/three'),
        ExpoTHREE = ___settings.externalLibraries.ExpoTHREE,
        AR = ___settings.externalLibraries.AR,
        GLOBAL_UTILS = require('../../../../../shared/util/GlobalUtils'),
        CameraHandlerInterface = require('../../../../interfaces/handlers/CameraHandlerInterface'),
        _settings = ___settings.settings,
        _container = ___settings.container,
        _handlers = ___handlers;


  let that,
      _camera,
      _orbitControls,
      _active = true;

  class CameraHandler extends CameraHandlerInterface {

    constructor() {
      super();
      that = this;

      _camera = new ExpoTHREE.AR.Camera(_container.width, _container.height, 0.01, 1000);
      _handlers.threeDManager.helpers.addSceneObject(_camera);
    }

    ////////////
    ////////////
    //
    // CameraHandler API
    //
    ////////////
    ////////////
    
    /** @inheritdoc */
    pause() {
      _active = false;
      _orbitControls.enabled = false;
      _orbitControls.resetState();
    }

    /** @inheritdoc */
    resume() { 
      _active = true;
      _orbitControls.enabled = true;
    }

    /** @inheritdoc */
    destroy() { 
      // destroy the camera handler
    }


    

    /** @inheritdoc */
    setPosition(position) {
      _handlers.threeDManager.debug('This method is not implemented in this viewport.');
    }

    /** @inheritdoc */
    resetPosition() {
      _handlers.threeDManager.debug('This method is not implemented in this viewport.');
    }

    /** @inheritdoc */
    getPosition() {
      return GLOBAL_UTILS.deepCopy(_camera.position);
    }




    /** @inheritdoc */
    setTarget(target) {
      _handlers.threeDManager.debug('This method is not implemented in this viewport.');
    }

    /** @inheritdoc */
    resetTarget() {
      _handlers.threeDManager.debug('This method is not implemented in this viewport.');
    }

    /** @inheritdoc */
    getTarget() {
      return GLOBAL_UTILS.deepCopy(_orbitControls.target);
    }




    /** @inheritdoc */
    setPositionAndTarget(position, target, options) {
      _handlers.threeDManager.debug('This method is not implemented in this viewport.');
    }

    /** @inheritdoc */
    resetPositionAndTarget(options) {
      _handlers.threeDManager.debug('This method is not implemented in this viewport.');
    }

    /** @inheritdoc */
    getPositionAndTarget() {
      return {
        position: that.getPosition(),
        target: that.getTarget()
      };
    }




    /** @inheritdoc */
    zoomExtents(options, bb) {
      _handlers.threeDManager.debug('This method is not implemented in this viewport.');
    }

    /** @inheritdoc */
    setCameraPath(positions, targets, options) {
      _handlers.threeDManager.debug('This method is not implemented in this viewport.');
    }




    /** @inheritdoc */
    getCamera() {
      return _camera;
    }

    /** @inheritdoc */
    isCameraMoving() {
      _handlers.threeDManager.debug('This method is not implemented in this viewport.');
    }

    /** @inheritdoc */
    updateOrbitControls() {
      _handlers.threeDManager.debug('This method is not implemented in this viewport.');
    }

    /** @inheritdoc */
    adjustToBoundingSphere(bs) {
      _handlers.threeDManager.debug('This method is not implemented in this viewport.');   
    }

    /** @inheritdoc */
    onResize(width, height) {
      _camera.aspect = width / height;
      _camera.setViewOffset(width, height, 0, 0, width, height);
      _camera.updateProjectionMatrix();
    }
  }

  return new CameraHandler();
};

module.exports = CameraHandler;
